import React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';

const SaveConfirmationModal = ({ isOpen, onCloseClick, onSaveClick }) => {
  return (
    <Modal isOpen={isOpen} size="md" centered>
      <ModalBody>
        <div className="d-flex flex-column justify-content-between align-items-center pt-4">
          <Icon.Save size={60} className="text-primary" />
          <div className="fs-4 pt-2">Are you sure?</div>
          <div className="fs-6 pt-2">
            Are you sure want to Save product?, Once Save you can not modify this.
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Button onClick={onCloseClick} className="px-5 bg-transparent text-primary">
          Cancel
        </Button>
        <Button onClick={onSaveClick} className="px-5 bg-primary border-primary">
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

SaveConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  onCloseClick: PropTypes.func,
  onSaveClick: PropTypes.func
};

export default SaveConfirmationModal;
